window.addEventListener("load", () => {
  const the_animation = document.querySelectorAll(
    ".top-supplement__progress-bar"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        function moveProgressBar(finalScore) {
          if (i == 0) {
            i = 1;
            let progressBar = entry.target;
            let width = 10;
            let id = setInterval(frame, 10);
            function frame() {
              if (width >= finalScore) {
                clearInterval(id);
                i = 0;
              } else {
                width++;
                progressBar.style.width = width + "%";
                progressBar.innerHTML = width + "%";
              }
            }
          }
        }

        if (entry.isIntersecting) {
          let finalScore = +entry.target.getAttribute("progress");
          moveProgressBar(finalScore);
        } else {
          return;
        }
      });
    },
    { threshold: 0.5 }
  );
  //
  for (let i = 0; i < the_animation.length; i++) {
    const elements = the_animation[i];
    observer.observe(elements);
  }

  const the_animation_circular =
    document.querySelectorAll(".circular-progress");

  const observerCircular = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        function moveCircularProgressBar() {
          let addedValue = +entry.target.getAttribute("progressValue");
          let progressStartValue = 0;
          let progressEndValue = addedValue;
          let speed = 10;

          let progress = setInterval(() => {
            progressStartValue++;

            entry.target.style.background = `conic-gradient(#34C659 ${
              progressStartValue * 3.6
            }deg, #E8E8E8 0deg)`;

            if (progressStartValue == progressEndValue) {
              clearInterval(progress);
            }
          }, speed);
        }

        if (entry.isIntersecting) {
          moveCircularProgressBar();
        } else {
          return;
        }
      });
    },
    { threshold: 0.5 }
  );
  //
  for (let i = 0; i < the_animation_circular.length; i++) {
    const elements = the_animation_circular[i];
    observerCircular.observe(elements);
  }
});
